import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SingleSelect from '../../../input_filed/SingleSelect';
import SaveButton from '../../../buttons/SaveButton';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import Text from '../../../input_filed/Text';
import Number from '../../../input_filed/Number';
import File from '../../../input_filed/File';
import { gateSchema } from './ValidationSchema';
import { addGateTodo } from '../../../../redux/slices/master/gate/AddGate';
import TextArea from '../../../input_filed/TextArea';

export default function AddGateForm() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [spiner, setSpiner] = useState(false)

    const status_option = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' }
    ];

    const initiaValues = {
        name: '',
        detail: '',
        password: '',
        // path: '',
        latitude: '',
        longitude: '',
        status: '',
        user_phone: '',
        gate_image: null,
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,
        validationSchema: gateSchema,
        onSubmit: (values) => {
            setSpiner(true)
            dispatch(addGateTodo(values)).then((res) => gate_res(res))
        }
    })

    const gate_res = (res) => {
        if (res?.payload?.status == 201 || res?.payload?.status == 200) {
            toast.success(res?.payload?.data?.message || 'Gate added', { position: "bottom-right" });
            setTimeout(() => {
                setSpiner(false);
                navigate('/gate-list')
            }, 1000);
        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
            setSpiner(false);
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
            setSpiner(false);
        } else if (res?.payload?.status == 404) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
            setSpiner(false);
        } else {
            setSpiner(false);
            toast.error(res?.payload?.data?.message || 'Error', { position: "bottom-right" });
        }
    }
    return (
        <>
            <Form onSubmit={handleSubmit}>
                <div className='main_layout'>
                    <div className='layout_head mb-3'>
                        <h5>Add Gate</h5>
                    </div>
                    <hr />
                    <div className='row'>
                        <div className='col-md-4'>
                            <Text
                                label_name='Name'
                                name='name'
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.name && touched.name && <span className='text-danger form_label'>{errors.name}</span>}
                            />
                        </div>
                        <div className='col-md-4'>
                            <TextArea
                                label_name='Detail'
                                name='detail'
                                rows={1}
                                value={values.detail}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.detail && touched.detail && <span className='text-danger form_label'>{errors.detail}</span>}
                            />
                        </div>
                        <div className='col-md-4'>
                            <Text
                                label_name='Password'
                                name='password'
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.password && touched.password && <span className='text-danger form_label'>{errors.password}</span>}
                            />
                        </div>

                        {/* <div className='col-md-4'>
                            <Text
                                label_name='Path'
                                name='path'
                                value={values.path}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.path && touched.path && <span className='text-danger form_label'>{errors.path}</span>}
                            />
                        </div> */}
                        <div className='col-md-4'>
                            <Number
                                label_name='Latitude'
                                name='latitude'
                                value={values.latitude}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.latitude && touched.latitude && <span className='text-danger form_label'>{errors.latitude}</span>}
                            />
                        </div>
                        <div className='col-md-4'>
                            <Number
                                label_name='Longitude'
                                name='longitude'
                                value={values.longitude}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.longitude && touched.longitude && <span className='text-danger form_label'>{errors.longitude}</span>}
                            />
                        </div>
                        <div className='col-md-4'>
                            <Number
                                label_name='User Phone'
                                name='user_phone'
                                value={values.user_phone}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.user_phone && touched.user_phone && <span className='text-danger form_label'>{errors.user_phone}</span>}
                            />
                        </div>
                        <div className='col-md-4'>
                            <SingleSelect
                                label_name='Status'
                                option={status_option}
                                name='status'
                                onChange={(e) => setFieldValue('status', e.value)}
                                onBlur={handleBlur}
                                error={errors.status && touched.status && <span className='text-danger form_label'>{errors.status}</span>}
                            />
                        </div>
                        <div className='col-md-4'>
                            <File
                                label_name='Gate Image'
                                name='gate_image'
                                onChange={(e) => setFieldValue('gate_image', e.target.files?.[0] || null)}
                                onBlur={handleBlur}
                                error={errors.gate_image && touched.gate_image && <span className='text-danger form_label'>{errors.gate_image}</span>}
                            />
                        </div>
                        <div className='d-flex justify-content-end mt-2'>
                            <SaveButton
                                spiner={spiner}
                                name={'SAVE'}
                            />
                        </div>
                    </div>
                </div>
            </Form>
        </>
    )
}


